import { render, staticRenderFns } from "./designer.vue?vue&type=template&id=c8a35286&scoped=true&"
import script from "./designer.vue?vue&type=script&lang=js&"
export * from "./designer.vue?vue&type=script&lang=js&"
import style0 from "./designer.vue?vue&type=style&index=0&id=c8a35286&scoped=true&lang=css&"
import style1 from "./designer.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./designer.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a35286",
  null
  
)

component.options.__file = "designer.vue"
export default component.exports